import { useLocalization } from "@i18n";

import { LanguageSwitcher } from "@i18n";
import { AppBackground } from "@shared/components";

interface TenantPageTemplateProps {
  logo: string;
  tenantFormSelect: React.ReactNode;
}

const TenantPageTemplate = ({ logo, tenantFormSelect }: TenantPageTemplateProps) => {
  const { translate } = useLocalization();

  return (
    <AppBackground className="flex justify-center w-full h-dvh">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 mt-[15px]">
        <img src={logo} alt="Logo" className="w-[230px] h-[77px]" />
      </div>
      <div className="w-full mt-[20vh] ml-[9vw] mr-[9vw] mb-[8vh] h-[calc(100vh-28vh)] overflow-auto">
        {tenantFormSelect}
      </div>

      <p className="absolute bottom-0 left-0 m-[15px]">
        {translate("common.tellusAllRightsReserved")}
      </p>

      <div className="absolute bottom-4 right-4">
        <LanguageSwitcher />
      </div>
    </AppBackground>
  );
};

export default TenantPageTemplate;
